import { NanQ } from "@pdfking/math"
import type { Time } from "@pdfking/structs"
import { UnixTime } from "@pdfking/tfunc"

import { ResponseHeader } from "./ResponseHeader"

/**
 * Gets Last-Modified from response as a unix time.
 *
 * Parses the Last-Modified header, which is a date in seconds resolution —
 * every store that keeps one keeps it there, so a caller asking when an entry
 * landed never has to know what kind of storage answered.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @returns The write time in seconds, or 0 when the header is absent or unreadable
 *
 * @example
 * ```ts
 * import { ResponseModifiedTime } from "@pdfking/io"
 *
 * const modified = ResponseModifiedTime(response)
 * ```
 */
export const ResponseModifiedTime = (r: Request | Response | XMLHttpRequest): Time => {
  const header = ResponseHeader(r, "last-modified")
  if (!header) return 0 as Time

  const date = new Date(header)
  return NanQ(date.getTime()) ? (0 as Time) : UnixTime(date)
}
